import React from 'react';
import styled, { css } from 'styled-components';
import {
  colors,
  Text,
  TypographyVariant,
} from '@sparknz/spark-pattern-library';

import extractModelId from 'shared/utils/extract-model-id';
import extractCQStyle, { CQStyleMap } from 'shared/utils/extractCQStyle';
import { TitleProps } from './TitleEditConfig';

const TextWrapper = styled.div<{ positionStyle: string }>`
  ${({ positionStyle }) => css`
    display: flex;
    width: 100%;
    justify-content: ${positionStyle};
  `}
`;

const variantPropCQStyleMap: CQStyleMap<TypographyVariant> = {
  'title--display': 'display',
  'title--headingL': 'headingL',
  'title--headingM': 'headingM',
  'title--headingS': 'headingS',
  'title--subheadingL': 'subheadingL',
  'title--subheadingM': 'subheadingM',
};

export type TitleColourProps = 'newZealandBlack' | 'wairua' | 'alto';

const fontColourPropCQStyleMap: CQStyleMap<TitleColourProps> = {
  'title-color--newZealandBlack': 'newZealandBlack',
  'title-color--wairua': 'wairua',
  'title-color--alto': 'alto',
};

export type TitlePositionProps = 'left' | 'center';

const positionPropCQStyleMap: CQStyleMap<TitlePositionProps> = {
  'title-position--left': 'left',
  'title-position--center': 'center',
};

const Title = (props: React.PropsWithChildren<TitleProps>) => {
  const {
    type,
    text,
    appliedCssClassNames: cssClassNames,
    cqPath,
    id: authorPassedId,
  } = props;
  const id = authorPassedId || extractModelId(cqPath);

  const variantStyle =
    extractCQStyle(variantPropCQStyleMap, cssClassNames) || 'headingL';
  const colourStyle =
    extractCQStyle(fontColourPropCQStyleMap, cssClassNames) ||
    'newZealandBlack';
  const positionStyle =
    extractCQStyle(positionPropCQStyleMap, cssClassNames) || 'left';

  return (
    <TextWrapper id={id} positionStyle={positionStyle}>
      <Text variant={variantStyle} component={type} color={colors[colourStyle]}>
        {text}
      </Text>
    </TextWrapper>
  );
};

export default Title;
